export default __webpack_public_path__ + "564e60fa367023aa1c799e9061ff9af2.jpg";